/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import colorSchemeSettingsUrl from "url:../assets/images/settings.png";

export const settingsContent = `
## Summary

Dexter's Settings allow you to customize your user experience. Currently, the primary setting available is **color scheme selection**, which lets you choose between Light, Dark, Colorblind Light, and Colorblind Dark themes to suit your visual preferences and accessibility needs.

Additional user settings and preferences will be added in future releases to provide more control over your Dexter experience.

---

## Changing Your Color Scheme

Dexter offers four color schemes to accommodate different visual preferences and lighting conditions.

<img src="${colorSchemeSettingsUrl}" alt="Color scheme selection in user dropdown" style="max-width: 400px; height: auto; display: block; margin: 12px auto;" />

### How to Use the Settings Menu

**Access Settings:**
1. Click the profile icon in the top-right corner
2. A dropdown menu appears
3. Look for the color scheme option icons

**Select a Theme:**
- Click **Light** for a bright, high-contrast interface
- Click **Dark** for a dark background with lighter text
- Click **Colorblind Light** for a colorblind-friendly palette on a light background
- Click **Colorblind Dark** for a colorblind-friendly palette on a dark background

**Canvas Background:**
- Select a preferred grid shape for the Transform Engine (or None for a solid color canvas)

**System Logger:**
- Review the toast notifications that have been generated by the application

**Change Password:**
- Opens a modal that allows the user to change their password

**Logout:**
- Logs the user out of the application

**Apply Changes:**
- Theme and Canvas Background applies immediately (no save button needed)
- Your selection persists across sessions
- All pages update to reflect the new theme

`;
